import React, { useState, useEffect, useCallback } from "react";
import { GetSalesList, DeleteSale } from "../../../server/SalesManagement";
import { setPreload } from "../../../server/CartsOpen";
import showAlert from "../../../server/ShowAlert";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { globalFileIcon } from "../../../../axiosInstance";
import { showAlertWithConfirmCancel } from "../../../server/ShowAlert";
import { Trash2 } from "lucide-react";

const SalesManagement = () => {
  const dispatch = useDispatch();
  const [salesList, setSalesList] = useState([]);
  const [_partialSalesList, setPartialSalesList] = useState([]);
  const stationId = useSelector((state) => state.user.stationId);

  const getSalesList = useCallback(() => {
    dispatch(setPreload(true));
    GetSalesList(stationId)
      .then((res) => {
        if (res.data) {
          setSalesList(res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching sales:", err);
        showAlert({ msg: "שגיאה בטעינת המבצעים" });
      })
      .finally(() => {
        dispatch(setPreload(false));
      });
  }, [dispatch, stationId]);

  useEffect(() => {
    if (stationId) getSalesList();
  }, [stationId, getSalesList]);

  const handleDeleteSale = (saleId) => {
    showAlertWithConfirmCancel({
      msgTitle: "האם את/ה בטוח/ה שברצונך למחוק את המבצע?",
      confirmText: "מחק",
      cancelText: "ביטול",
      onConfirm: () => {
        DeleteSale(saleId)
          .then(() => {
            showAlert({ msgTitle: "המבצע נמחק בהצלחה", msgType: "success" });
            setSalesList((prev) =>
              prev.filter(
                (item) => item.Id !== saleId && item.promoId !== saleId,
              ),
            );
            setPartialSalesList((prev) =>
              prev.filter(
                (item) => item.Id !== saleId && item.promoId !== saleId,
              ),
            );
          })
          .catch(() => {
            showAlert({
              msgTitle: "הייתה בעיה במחיקת המבצע",
              msgType: "error",
            });
          });
      },
    });
  };

  const normalizeDate = (date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const getSaleDescription = (item) => {
    let promoText = "";
    switch (item.promoType) {
      case "QUANTITY_PRICE":
        promoText = `${item.minQuantity} ב-${item.discountValue} ₪`;
        break;
      case "PERCENT":
        promoText = `${item.discountValue}% הנחה`;
        break;
      case "FLAT":
        promoText = `רק ${item.discountValue} ₪`;
        break;
      default:
        promoText = `${item.discountValue} ₪`;
    }

    const manualText = item.description || item.Text || "";

    return (
      <div
        style={{
          lineHeight: "1.3",
          padding: "5px",
          display: "flex",
          flexDirection: "column",
          gap: "4px",
        }}
      >
        <div style={{ fontWeight: "900", fontSize: "20px" }}>{promoText}</div>
        {manualText && (
          <div style={{ fontSize: "15px", fontWeight: "600" }}>
            {manualText}
          </div>
        )}
        {!manualText && (
          <div style={{ fontSize: "12px", opacity: 0.8, fontWeight: "500" }}>
            {item.promoId}
          </div>
        )}
      </div>
    );
  };

  const renderSaleItem = (item) => (
    <div className="all-sale-list" key={item.Id || item.promoId}>
      <button
        type="button"
        className="deleteSale"
        onClick={() => handleDeleteSale(item.promoId)}
        aria-label="מחיקה"
        title="מחיקה"
      >
        <Trash2 aria-hidden size={18} strokeWidth={2} />
      </button>
      <NavLink
        to={"/sale-page"}
        state={{ saleData: item }}
        className="sale-item"
        style={{
          backgroundImage: `url(${globalFileIcon + "addressBg.svg"})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundColor: "transparent",
          width: "140px",
          height: "130px",
          margin: "5px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          color: "white",
          textDecoration: "none",
          direction: "rtl",
        }}
      >
        {getSaleDescription(item)}
      </NavLink>
    </div>
  );

  const activeSales = salesList.filter((item) => {
    const today = normalizeDate(new Date());
    const start = normalizeDate(new Date(item.startDate));
    const end = normalizeDate(new Date(item.endDate));
    return start <= today && end >= today;
  });

  return (
    <div className="show-sales">
      <h1 className="title-role">ניהול מבצעים</h1>
      <div className="sale-item-list">{salesList.map(renderSaleItem)}</div>
      <h2 className="saleRole">מבצעים בתוקף:</h2>
      <div className="sale-item-list">{activeSales.map(renderSaleItem)}</div>
    </div>
  );
};

export default SalesManagement;
